import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import useSidebarStore from '../../store/sidebarStore';
import * as S from './SideNavBar.style';

const SideNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const { isExpanded, toggleSidebar } = useSidebarStore();

  // 현재 경로를 기반으로 activeNavItem 결정
  const getActiveNavItem = () => {
    const path = location.pathname;
    if (path.includes('/upload')) return 'upload';
    if (path.includes('/trim') || path.includes('/mapping')) return 'edit';
    if (path.includes('/generate')) return 'report';
    return 'upload'; // 기본값
  };

  const activeNavItem = getActiveNavItem();

  const handleNavItemClick = (item) => {
    console.log('[SIDEBAR]', 'Navigation item clicked:', item);
    
    switch (item) {
      case 'upload':
        navigate('/upload');
        break;
      case 'edit':
        navigate('/trim');
        break;
      case 'report':
        navigate('/generate');
        break;
      default:
        navigate('/upload');
    }
  };

  const handleUtilityClick = (type) => {
    console.log('[SIDEBAR]', 'Utility button clicked:', type);
    // 유틸리티 기능 구현
  };

  const handleLogout = () => {
    console.log('[SIDEBAR]', 'Logout clicked');
    logout();
    navigate('/login');
  };

  const handleToggleSidebar = () => {
    toggleSidebar();
  };

    return (
    <S.SidebarContainer isExpanded={isExpanded}>
      {/* 토글 버튼 */}
      <S.ToggleButton onClick={handleToggleSidebar} isExpanded={isExpanded}>
        <S.ToggleIcon isExpanded={isExpanded} />
      </S.ToggleButton>

    <S.SidebarHeader isExpanded={isExpanded}>
      {isExpanded ? (
        <S.LogoOption>
          <S.LogoImage src="/assets/logo-expanded.jpg" alt="Pivo Logo" />
        </S.LogoOption>
      ) : (
        <S.CollapsedLogo>
          <S.LogoImage src="/assets/logo-collapsed.jpg" alt="Pivo" />
        </S.CollapsedLogo>
      )}
    </S.SidebarHeader>

      <S.Navigation isExpanded={isExpanded}>
        {isExpanded && <S.NavTitle>메뉴</S.NavTitle>}
        <S.NavList>
          <S.NavItem 
            isActive={activeNavItem === 'upload'}
            onClick={() => handleNavItemClick('upload')}
            isExpanded={isExpanded}
            title={!isExpanded ? '파일 업로드' : ''}
          >
            <S.NavIcon type="upload" />
            {isExpanded && <S.NavText>데이터 업로드</S.NavText>}
          </S.NavItem>
          <S.NavItem 
            isActive={activeNavItem === 'edit'}
            onClick={() => handleNavItemClick('edit')}
            isExpanded={isExpanded}
            title={!isExpanded ? '파일 편집' : ''}
          >
            <S.NavIcon type="edit" />
            {isExpanded && <S.NavText>데이터 관리</S.NavText>}
          </S.NavItem>
          <S.NavItem 
            isActive={activeNavItem === 'report'}
            onClick={() => handleNavItemClick('report')}
            isExpanded={isExpanded}
            title={!isExpanded ? '보고서 생성' : ''}
          >
            <S.NavIcon type="report" />
            {isExpanded && <S.NavText>분석 실행 및 결과보고서 생성</S.NavText>}
          </S.NavItem>
        </S.NavList>
      </S.Navigation>

      <S.UserSection isExpanded={isExpanded}>
        {isExpanded ? (
          <>
            {/* <S.UtilityButtons>
              <S.UtilityButton 
                type="settings" 
                onClick={() => handleUtilityClick('settings')}
                title="설정"
              />
              <S.UtilityButton 
                type="notification" 
                onClick={() => handleUtilityClick('notification')}
                title="알림"
              />
              <S.UtilityButton 
                type="help" 
                onClick={() => handleUtilityClick('help')}
                title="도움말"
              />
            </S.UtilityButtons> */}
            <S.UserInfo>
              <S.UserAvatar>
                {user?.avatar ? (
                  <img src={user.avatar} alt={user.name} />
                ) : (
                  <S.AvatarPlaceholder>
                    {user?.name?.charAt(0) || 'U'}
                  </S.AvatarPlaceholder>
                )}
              </S.UserAvatar>
              <S.UserDetails>
                <S.UserName>{user?.name || '사용자'}</S.UserName>
                {/* <S.UserDepartment>{user?.department}</S.UserDepartment> */}
              </S.UserDetails>
              <S.LogoutButton onClick={handleLogout} title="로그아웃" />
            </S.UserInfo>
          </>
        ) : (
          <S.CollapsedUserSection>
            {/* <S.CollapsedUtilityButtons>
              <S.CollapsedUtilityButton 
                type="settings" 
                onClick={() => handleUtilityClick('settings')}
                title="설정"
              />
              <S.CollapsedUtilityButton 
                type="notification" 
                onClick={() => handleUtilityClick('notification')}
                title="알림"
              />
              <S.CollapsedUtilityButton 
                type="help" 
                onClick={() => handleUtilityClick('help')}
                title="도움말"
              />
            </S.CollapsedUtilityButtons> */}
            <S.CollapsedUserInfo>
              <S.UserAvatar>
                {user?.avatar ? (
                  <img src={user.avatar} alt={user.name} />
                ) : (
                  <S.AvatarPlaceholder>
                    {user?.name?.charAt(0) || 'U'}
                  </S.AvatarPlaceholder>
                )}
              </S.UserAvatar>
              <S.CollapsedLogoutButton onClick={handleLogout} title="로그아웃" />
            </S.CollapsedUserInfo>
          </S.CollapsedUserSection>
        )}
      </S.UserSection>
    </S.SidebarContainer>
  );
};

export default SideNavBar;